/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { CardFrontTestIds } from '@trello/test-ids';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { MemberTemplate } from './MemberTemplate';
const t = teacupWithHelpers('member_on_card');

// eslint-disable-next-line @trello/no-module-logic
export const MemberOnCardTemplate = t.renderable(
  ({
    avatarUrl,
    fullName,
    id,
    initials,
    isDeactivated,
    isBoardAdmin,
    isOrganizationAdmin,
    isVirtual,
    username,
    viewTitle,
    activityBlocked,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) =>
    t.div(
      '.member.js-member-on-card-menu',
      {
        class: t.classify({
          'member-deactivated': isDeactivated || activityBlocked,
          'member-virtual': isVirtual,
          'long-initials': (initials != null ? initials.length : undefined) > 2,
        }),
        'data-idmem': id,
        'data-testid': CardFrontTestIds.CardFrontMember,
      },
      () =>
        MemberTemplate({
          avatarUrl,
          fullName,
          initials,
          isDeactivated,
          isBoardAdmin,
          isOrganizationAdmin,
          username,
          viewTitle,
        }),
    ),
);
